module.exports = __webpack_public_path__ + "static/img/downimg_en.5ff3229.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home_model/downimg_en.png
// module id = INa+
// module chunks = 80